<template>
  <div class="block" v-if="debt.debtor_iin">
      <ul class="nav nav-tabs nav-tabs-alt align-items-center js-tabs-enabled" data-toggle="tabs" role="tablist">
          <li class="nav-item">
              <a class="nav-link active" id="phones-tab" data-toggle="tab" href="#phones" role="tab" aria-controls="phones" aria-selected="true">
                {{ $t('phones.index') }}
              </a>
          </li>
          <li class="nav-item">
              <a class="nav-link" id="addresses-tab" data-toggle="tab" href="#addresses" role="tab" aria-controls="addresses" aria-selected="false">
                {{ $t('addresses.index') }}
              </a>
          </li>
          <li class="nav-item ml-auto">
            <div class="btn-group btn-group-sm mr-15">
                <b-btn v-b-modal.addphone size="sm" variant="secondary">
                  <i class="fa fa-plus"></i> {{ $t('phones.add') }}
                </b-btn>
                <b-btn v-b-modal.addAddress size="sm" variant="secondary">
                  <i class="fa fa-plus"></i> {{ $t('addresses.add') }}
                </b-btn>
            </div>
          </li>
      </ul>
      <div class=" tab-content" >
          <div class="tab-pane active" id="phones" role="tabpanel" aria-labelledby="phones-tab">
              <phones/>
          </div>
          <div class="tab-pane" id="addresses" role="tabpanel" aria-labelledby="addresses-tab">
              <addresses/>
          </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import Addresses from '@/components/employee/debt/contacts/addresses';
import Phones from '@/components/employee/debt/contacts/phones';

export default {
  data() {
    return {
      isProcessing: false,
      today: moment().format('YYYY-MM-DD'),
    };
  },
  computed: {
    ...mapGetters([
      'debt',
    ]),
  },
  components: {
    Addresses,
    Phones,
  },
};
</script>
